import type { To } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { InstitutionFuturesProgressStep } from '@/context/progress';
import FuturesClientCategorisationLayout from '@/features/futures/layouts/client-categorisation';
import ServicesAgreement from '@/features/services-agreement/components/agreement';
import { useProfileInstitutionDetailsAnswers } from '@/hooks/queries/use-profile-institution-details';
import LoadingPage from '@/pages/loading';

type InstitutionFuturesServicesAgreementPageProps = {
  next?: To;
};

const InstitutionFuturesServicesAgreementPage = ({ next = '/futures/verification' }: InstitutionFuturesServicesAgreementPageProps) => {
  const { isLoading, data: institutionDetailsAnswers } = useProfileInstitutionDetailsAnswers();

  if (isLoading) return <LoadingPage />;

  if (!institutionDetailsAnswers?.company?.leiNumber) return <Navigate to="/institution/futures/company-information" replace />;

  return (
    <FuturesClientCategorisationLayout step={InstitutionFuturesProgressStep.CLIENT_CATEGORISATION} fill>
      <ServicesAgreement next={next} />
    </FuturesClientCategorisationLayout>
  );
};
InstitutionFuturesServicesAgreementPage.displayName = 'InstitutionFuturesServicesAgreementPage';

export default InstitutionFuturesServicesAgreementPage;
